module.exports = __webpack_public_path__ + "static/media/logoqi.8ffc4e12.svg";